import $ from 'jquery'
import { error as logError } from '@/utils/logging'
import '@/requestManager'

// Time out after 45 seconds globally. Cloudflare limit for response to start is 100 seconds (not configurable).
// Some extended blocking / waiting requests may define individually extended timeouts as needed,
// although it's preferable that APIs are designed so this isn't necessary.
$.ajaxSetup({
  timeout: 45 * 1000
})

// Create a global AJAX handler to alert us of all AJAX errors on the site
$(document).ajaxError(
  (event, jqXHR, ajaxSettings: JQuery.AjaxSettings, thrownError) => {
    // Don't log errors for requests which are aborted, or have an explicitly defined
    // `suppressErrorLogging` settings property which contains a callback function returning true.
    if (
      ajaxSettings.suppressErrorLogging?.(
        event,
        jqXHR,
        ajaxSettings,
        thrownError
      ) ||
      thrownError === 'abort' ||
      thrownError === 'timeout'
    ) {
      return
    }

    const url = ajaxSettings.url
    // Report any Ajax request that throws an error- except Unauthorized errors. Sessions expire after two
    // hours, so we expect they'll throw `Unauthorized` errors and Commerce will create a new session for them.
    if (
      thrownError !== 'Unauthorized' &&
      jqXHR.status !== 401 &&
      url &&
      // Ignore URLs that are frequently ad-blocked
      url.indexOf('marketo.net/') === -1
    ) {
      // Use regex to remove jQuery param that disables cache for GET requests so errors are grouped
      logError(
        'AJAX error on ' + decodeURIComponent(url.replace(/&_=\d+/, '')),
        {
          thrownError,
          jqXHR,
          ajaxSettings
        }
      )
    }
  }
)

// Allow this to be included instead of jQuery to ensure that settings have been initialized
export default $
